<template>
  <v-form
    ref="form"
    class="new-password-component mt-3"
    @submit.prevent="changeSecondStageOrSaveNewPassword()"
  >
    <v-flex
      v-if="error.message"
      xs12
      class="pa-3 pb-0"
    >
      <alert-message :error.sync="error" />
    </v-flex>
    <password-recovery-code
      v-if="!payload.code"
      v-model="payload.code"
    />
    <v-container v-if="payload.code">
      <v-layout
        row
        wrap
      >
        <v-flex
          v-if="!recoverSuccess"
          class="py-0"
          xs12
        >
          <h1>{{ $t('app.login.newPasswordComponent.title') }}</h1>
        </v-flex>
        <v-flex
          v-if="recoverSuccess"
          class="text-xs-center py-0"
          xs12
        >
          <v-icon
            class="pr-2 large-icon"
            color="#00BD00"
          >
            check_circle_outline
          </v-icon>
          <h5>{{ $t('app.login.newPasswordComponent.success') }}</h5>
        </v-flex>
        <v-flex
          v-if="isFirstStage"
          class="py-0"
          xs12
        >
          <span class="colored">
            {{ $t('app.login.newPasswordComponent.unit_simple') }}
            <b class="bold">{{ $t('app.login.newPasswordComponent.unit_bold') }}</b>
          </span>
        </v-flex>
        <v-flex
          v-if="isSecondStage"
          class="py-0"
          xs12
        >
          <span class="colored">
            {{ $t('app.login.newPasswordComponent.second_simple') }}
            <b class="bold">
              {{ $t('app.login.newPasswordComponent.second_bold') }}
            </b>
          </span>
        </v-flex>
        <v-flex
          v-if="!recoverSuccess"
          class="py-0"
          xs12
        >
          <span class="subtitle">{{ $t('app.login.newPasswordComponent.subtitle') }}</span>
        </v-flex>
        <v-flex
          v-if="isFirstStage"
          class="py-0"
          xs12
        >
          <input-password
            v-model="payload.password"
            required
            :rules="[minLength(8), maxLength(20)]"
            :label="$t('app.login.newPasswordComponent.newPassword')"
          />
        </v-flex>
        <v-flex
          v-if="isSecondStage"
          class="py-0"
          xs12
        >
          <input-password
            v-model="payload.confirmPassword"
            required
            :rules="passwordConfirmationRules"
            :label="$t('app.login.newPasswordComponent.confirmPassword')"
          />
        </v-flex>
        <v-flex
          class="py-0 mx-auto"
          xs8
        >
          <btn-primary
            id="newPasswordButton"
            block
            :text="showMessageInStageCorrect"
            @click="changeSecondStageOrSaveNewPassword()"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import InputPassword from 'Support/components/inputs/InputPassword.vue';
import AlertMessage from 'Support/components/alerts/AlertMessage.vue';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import RecoverService from 'Domain/recoverPassword/RecoverService';
import PageableMixin from 'Support/components/lists/mixins/pageable.mixin';
import FormMixin from 'Support/components/crud/form-mixin';
import RulesMixin from 'Support/mixins/rules-mixin';
import PasswordRecoveryCode from 'App/login/components/PasswordRecoveryCode.vue';

export default {
  name: 'NewPassword',
  components: {
    BtnPrimary,
    InputPassword,
    AlertMessage,
    PasswordRecoveryCode,
  },
  mixins: [PageableMixin, FormMixin, RulesMixin],
  data() {
    return {
      passwordConfirmationError: 'support.components.inputs.passwordConfirmation',
      payload: {
        password: '',
        confirmPassword: '',
        code: '',
      },
      secondStep: false,
      recoverSuccess: false,
      loading: false,
      error: {},
    };
  },
  computed: {
    showMessageInStageCorrect() {
      if (this.isFirstStage) {
        return this.$t('app.login.newPasswordComponent.continue');
      }
      return this.$t('app.login.newPasswordComponent.confirm');
    },
    isFirstStage() {
      return !this.recoverSuccess && !this.secondStep;
    },
    isSecondStage() {
      return !this.recoverSuccess && this.secondStep;
    },
    passwordConfirmationRules() {
      return [
        this.minLength(8),
        this.maxLength(20),
        v => v === this.payload.password || this.$t(this.passwordConfirmationError),
      ];
    },
  },
  methods: {
    changeSecondStageOrSaveNewPassword() {
      if (this.validateForm() && this.isFirstStage) {
        this.secondStep = true;
        return this.secondStep;
      }
      return this.save();
    },
    save() {
      if (!this.validateForm()) {
        return;
      }
      const query = {
        codigoVerificador: this.payload.code,
        novaSenha: this.payload.password,
        confirmacaoSenha: this.payload.confirmPassword,
      };
      const loader = this.$loading.show();

      RecoverService
        .change(query)
        .then(() => {
          this.recoverSuccess = true;
        })
        .catch(({ response }) => {
          this.error = response.data;
          this.payload.code = '';
          this.payload.password = '';
          this.payload.confirmPassword = '';
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
  .new-password-component
    h1
      font-style normal
      font-weight bold
      font-size 36px
      line-height 39px
      color #113752
    .large-icon
      font-size 48px
    h5
      font-size: 15px
      line-height 29px
      text-align: center
      color: #369ce2
    .subtitle
      font-style normal
      font-weight 600
      font-size 10px
      line-height 12px
      color #BDBDBD
    .colored
      color: #113752
      font-size: 15px
</style>
